module.exports = __webpack_public_path__ + "img/28.a985b12a.png";